"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TranslationContext = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var logged = false;

var defaultTranslationFunction = function defaultTranslationFunction(translationKey, options) {
  if (!logged && process.env.NODE_ENV !== 'test') {
    console.error(" You used the default translation function which is not ment for production.\n  Please wrap the <JobCard /> with a JobCard/TranslationProvider in order to use your translations.\n  ");
    logged = true;
  }

  if ((0, _typeof2["default"])(options) !== 'object') {
    return translationKey;
  }

  return Object.keys(options).reduce(function (acc, key) {
    return acc.replace("{".concat(key, "}"), options[key]);
  }, translationKey);
};

var TranslationContext = (0, _react.createContext)(defaultTranslationFunction);
exports.TranslationContext = TranslationContext;

var TranslationProvider = function TranslationProvider(props) {
  var _props$translationFun = props.translationFunction,
      translationFunction = _props$translationFun === void 0 ? defaultTranslationFunction : _props$translationFun,
      children = props.children;
  return (0, _core.jsx)(TranslationContext.Provider, {
    value: translationFunction
  }, children);
};

var _default = TranslationProvider;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logged, "logged", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/TranslationProvider/index.tsx");
  reactHotLoader.register(defaultTranslationFunction, "defaultTranslationFunction", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/TranslationProvider/index.tsx");
  reactHotLoader.register(TranslationContext, "TranslationContext", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/TranslationProvider/index.tsx");
  reactHotLoader.register(TranslationProvider, "TranslationProvider", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/TranslationProvider/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/TranslationProvider/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();